// extracted by mini-css-extract-plugin
export default {"formHeading":"RH-z","form":"SH-z","submitBtn":"TH-z","disabled":"UH-z","input":"VH-z","error":"WH-z","submitMsg":"XH-z","signIn":"YH-z"};